/** Tracks which items have had a dev warning triggered already. */
const devWarningLimit = new Set<string>();

/**
 * Generates a developer warning.  This is a common function that allows warnings to be nicely limited in order to prevent overloading the
 * browser console with the same warning over and over.
 * @param message {string} The development only warning to write to the console.
 * @param limitFactors {object} Causes to prevent displaying the EXACT same development warning over and over.
 * @param moreDetails {object} Optional. Any additional details that make it easier to diagnose the issue being reported.
 */
export default function createDevWarning(
	message: string,
	limitFactors: { file?: string; warning?: string; detail?: string; extra?: string } = {},
	moreDetails?: object
) {
	// No dev warnings if not in debug mode
	if (process.env.NODE_ENV !== "development") return;

	const limitFactor = `#${limitFactors.file || ""}#-#${limitFactors.warning || ""}#-#${limitFactors.detail ||
		""}#-#${limitFactors.extra || ""}#`;
	if (limitFactor !== "##-##-##-##") {
		/* If no limit was passed, just execute the warning */ // Don't run a warning that has already been executed
		if (devWarningLimit.has(limitFactor)) return;

		devWarningLimit.add(limitFactor);
	}

	// Log the warning
	console.warn(message, { ...moreDetails, limitFactors });
}
